// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2ux3X","footer":"ModalFilter_footer__1oBeE"};